<template>
	<div id='iframe_pl'>
		<h1 style='text-align:center'>{{ settingObj.name }} : Variantes</h1>
		<webView :settingId="settingObj.id" path="/variants" :queryString="'display='+ display" />
	</div>
</template>

<script>
	import FctUtils from '@/components/FctUtils';
	import WebView from '@/components/WebViewProLexis';

	export default { 
		name: 'VariantsFrame',

		mixins: [FctUtils],
		components: {
			'webView': WebView,
		},
		props: {
			settingObjStr:{ type: String },
			displayType:  { type: Number, required: false, default: 0 }
		},
		data(){
			return {
				settingObj: {},
				display: 0
			}
		},

		created() {
			// Si pas de settings, on regarde s'il n'y en a pas un déjà dans le store
			//
			if (!FctUtils.methods.noEmpty(this.settingObjStr)) {
				this.settingObj = this.$store.getters.setting;
			}
			else {
				this.settingObj = JSON.parse(this.settingObjStr);
			}

			// Si pas de setting, on retourne à la sélection.
			//
			if (! FctUtils.methods.noEmpty(this.settingObj)) {
				this.$router.push({name:"SelectDicoSetting", params: { from: "VariantsFrame"}});
			}

			// On ne prend que si la valeur est valide
			//
			if ((this.displayType <= 1) && (this.displayType >= 0)) {
				this.display = this.displayType;
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#iframe_pl {
	height : calc(100% - 0px);
}
</style>
